// features/roles/api/roles.api.js
// Capa de API para gestión de roles.
// Reemplaza gradualmente: roles.resource.js (BaseService 'roles')
//
// BaseService:
//   GET    /api/roles          → getAll
//   GET    /api/roles/names    → getNames
//   POST   /api/roles          → create
//   PUT    /api/roles/:id      → update
//   DELETE /api/roles/:id      → remove

import { api } from '../../../api/client';

export const rolesApi = {
  /** Lista todos los roles */
  search: (searchData) =>
    api.post('/roles/search',searchData),

  /** Lista nombres/ids simplificados (para selects) */
  getNames: () =>
    api.get('/roles/names'),

  /**
   * Crea un rol
   * @param {object} data
   */
  create: (data) =>
    api.post('/roles', data),

  /**
   * Actualiza un rol por id
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) =>
    api.put(`/roles/${id}`, data),

  /**
   * Elimina un rol por id
   * @param {string|number} id
   */
  remove: (id) =>
    api.delete(`/roles/${id}`),
  //filtro
  getNames:()=>api.get('/roles/getNames')
};
